module.exports = __webpack_public_path__ + "static/media/black-checkmark-icon.a757ac0b.svg";